import { render } from "./InviteSubAgent.vue?vue&type=template&id=48f16b0e"
import script from "./InviteSubAgent.vue?vue&type=script&lang=js"
export * from "./InviteSubAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__